module.exports = __webpack_public_path__ + "static/media/V2_04.b3b679d8.png";